module.exports = __webpack_public_path__ + "static/media/IMG_7614-min.eeb0ad38.jpg";